"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonOnboardingStepTypes = void 0;
const CommonOnboardingStepId_1 = require("./CommonOnboardingStepId");
const EmailVerificationStep_1 = require("../../email/domain/EmailVerificationStep");
const IdentityStep_1 = require("../../identity/domain/IdentityStep");
const PaymentInfoStep_1 = require("../../payment/domain/PaymentInfoStep");
const keyedRecord_1 = require("../../infrastructure/keyedRecord");
exports.CommonOnboardingStepTypes = (0, keyedRecord_1.keyedRecord)()({
    [CommonOnboardingStepId_1.CommonOnboardingStepId.EMAIL_VERIFICATION]: EmailVerificationStep_1.EmailVerificationStep,
    [CommonOnboardingStepId_1.CommonOnboardingStepId.IDENTITY]: IdentityStep_1.IdentityStep,
    [CommonOnboardingStepId_1.CommonOnboardingStepId.PAYMENT_INFO]: PaymentInfoStep_1.PaymentInfoStep,
});
//# sourceMappingURL=CommonOnboardingStepTypes.js.map